module.exports = __webpack_public_path__ + "img/call.a51d1985.svg";